module.exports = __webpack_public_path__ + "img/point.ca1ff410.png";